export default "__VITE_ASSET__DRD1oavq__"